import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0;
  padding: 1.5rem;
`;

export const HeaderSection = styled.div`
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const SubTitle = styled.h4`
  font-size: 0.875rem;
  color: #6b7280;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const Button = styled.div`
  background-color: white;
  color: #4b5563;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ActiveButton = styled.button`
  background-color: #59249b;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  outline: none;
  border: none;
  gap: 0.5rem;
`;

export const Icon = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.5rem;
`;

export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const FilterColumn = styled.div`
  grid-column: span 1;
`;

export const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.25rem;
`;

export const DateFilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const DateInputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const DateLabel = styled.span`
  font-size: 0.875rem;
`;

export const DateInput = styled.input`
  margin-top: 0.25rem;
  width: 8rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  &:focus {
    outline: none;
    border-color: #59249b;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
  margin-left: auto;
`;

export const PrimaryButton = styled.button`
  background-color: #59249b;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: #59249b;
  }
`;

export const SecondaryButton = styled.button`
  background-color: white;
  color: #59249b;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid #59249b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export const DownloadButton = styled.button`
  height: 32px;
  width: 40px;
  background-color: #59249b;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px 8px 18px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #59249b;
  }

  &:disabled {
    background-color: #c4c4c4;
    cursor: not-allowed;
  }
`;

export const ChartGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ChartCard = styled.div`
  background-color: white;
  padding: 0.75rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  canvas {
    max-width: 25vw;
    max-height: 200px;
  }
`;

export const ChartTitle = styled.h3`
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
`;

export const ChartSplitContainer = styled.div`
  display: flex;
`;

export const ChartSideInfo = styled.div`
  width: 33.333333%;
  display: flex;
  align-items: center;
`;

export const ChartMainContent = styled.div`
  width: 66.666667%;
`;

export const ChartInfoText = styled.p`
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
`;

export const ChartInfoTextRight = styled.p`
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  text-align: right;
`;

export const TableWrapper = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  overflow-x: auto;
`;

export const StyledTable = styled.table`
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
`;

export const TableHead = styled.thead`
  background-color: #f3f4f6;
`;

export const TableBody = styled.tbody`
  background-color: white;
`;

export const TableRow = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #e5e7eb;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 0.75rem 1.5rem;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  color: #6b7280;
  letter-spacing: 0.05em;

  &:nth-child(3),
  &:nth-child(4),
  &:nth-child(5),
  &:nth-child(6) {
    text-align: center;
  }
`;

export const TableCell = styled.td`
  padding: 1rem 1.5rem;
  white-space: nowrap;
  font-size: 0.875rem;
  color: #111827;
`;

export const TableCellCenter = styled.td`
  padding: 1rem 1.5rem;
  white-space: nowrap;
  font-size: 0.875rem;
  color: #111827;
  text-align: center;
`;
